import React from "react";
import { Container, Row, Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import logo from "../assets/images/connectai_logo_branca.png";

interface NewPasswordLayoutProps {
  children: React.ReactNode;
}

const NewPasswordLayout: React.FC<NewPasswordLayoutProps> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <div
      style={{ width: "100%" }}
      className="auth-bg d-flex flex-column min-vh-100"
    >
      <Container
        fluid
        className="p-0 h-100 d-flex justify-content-center align-items-center page-content-np"
      >
        <Row className="responsive h-100 w-100 d-flex justify-content-center align-items-center">
          <Col
            md={5}
            className="d-flex flex-column align-items-center justify-content-center logo-aligned"
            style={{ zIndex: 1 }}
          >
            <div className="welcome-section-np text-center text-md-start">
              <div className="logo-section mb-5">
                <img src={logo} alt="Logo" className="logo-img" />
              </div>
              <div className="welcome">
                <h1>
                  <span className="highlight">{t("Create New Password")}</span>{" "}
                  {t("to continue using our services.")}
                </h1>
              </div>
            </div>
            <div
              className="footer-text mt-auto"
              style={{ color: "white", textAlign: "center" }}
            >
              <a
                href="https://ittech.digital/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link footer-text"
              >
                &copy;It Tech
              </a>
            </div>
          </Col>
          <Col
            md={7}
            className="d-flex align-items-center justify-content-center card-recoverpw"
            style={{ zIndex: 2 }}
          >
            <div className="authentication-page-content">{children}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NewPasswordLayout;
